export const MemberCategoryConstants = {
    OCCASIONAL_HUNTER: 'c70368eb-8b9c-43af-800d-02d3989911c3',
    DEDICATED_SPORTPERSON: '87f1f6bc-3aa5-4066-b9f5-a3493c862c95',
    OCCASIONAL_HUNTER_AND_SPORTPERSON: 'faa700b9-a7fe-4f13-aa90-b1e3097f45dc',
    DEDICATED_HUNTER: '180d09e3-d160-4fde-bf4a-bf9b298db36d',
    OCCASIONAL_SPORTPERSON: 'cec9a69a-04da-4905-a890-c60c4ff58961',
    DEDICATED_HUNTER_AND_OCCASIONAL_SPORTPERSON: 'cc2723d4-73a9-4146-8f5a-d26c344d1300',
    DEDICATED_SPORTPERSON_AND_OCCASIONAL_HUNTER: 'bc789dd0-f036-4c2e-b688-ea24e22e4b09',
    DEDICATED_HUNTER_AND_SPORTPERSON: 'abb93fb5-14bf-43ff-b258-f6b76e35d95c'
}